const UPDATE_FIELD = 'UPDATE_FIELD';
const RESET_FORM = 'RESET_FORM';

export { UPDATE_FIELD, RESET_FORM };



// WEBPACK FOOTER //
// ./src/store/ContactForm/types.js